import React from 'react';

import { useAdobeDataLayer, PageNames } from '../../hooks/useAdobeDataLayer';
import contactUsImage from 'url:../../assets-optimized/redesign/contact/contact_us_cta.jpg';
import contactUsImageavif from 'url:../../assets-optimized/redesign/contact/contact_us_cta.avif';
import contactUsImagewebp from 'url:../../assets-optimized/redesign/contact/contact_us_cta.webp';
import OptimizedImage from '../../components/Redesign/OptimizedImage';
import ActionButton from '../../components/elements/ActionButton/ActionButton';
import useContactForm from '../../hooks/useContactForm';
import ContactFormFields, { ContactSuccessIcon } from '../../components/Redesign/ContactFormFields';

import './Contact.css';

const Contact = () => {
  const { sendPageView } = useAdobeDataLayer();
  const {
    formData,
    errors,
    isSubmitting,
    submitError,
    showSuccessMessage,
    handleChange,
    handleSubmit,
    resetForm,
  } = useContactForm(() => {
    setTimeout(resetForm, 10000);
  }, PageNames.Contact);

  React.useEffect(() => {
    sendPageView(PageNames.Contact);
  }, [sendPageView]);

  return (
    <>
      <div className='contact-page-wrapper'>
        <div className='contact-banner-container'>
          <div className='contact-banner_page'>
            <h1 className='contact-banner-title'>LET’S CONNECT!</h1>
            <p className='contact-banner-subtitle'>
              Reach out to us, and we'll schedule a call soon.
            </p>
          </div>
        </div>

        <div className='contact-content-section'>
          <div className='contact-form-container'>
            <form onSubmit={handleSubmit} className='contact-form'>
              <ContactFormFields
                formData={formData}
                errors={errors}
                handleChange={handleChange}
              />

              {submitError && (
                <div className='contact-error-message' role='alert'>
                  <span>{submitError}</span>
                </div>
              )}
              {showSuccessMessage && (
                <div className='contact-success-message' role='status'>
                  <ContactSuccessIcon />
                  <span>We have received your message and will respond soon!</span>
                </div>
              )}
              <div className='form-submit-row'>
                <div className='form-submit-container'>
                  <ActionButton
                    onClick={handleSubmit}
                    text={isSubmitting ? 'Sending...' : 'Contact Us'}
                    disabled={isSubmitting || showSuccessMessage}
                    clickTrackValue='Contact|Contact Us|Internal|'
                    fullWidth
                  />
                </div>
                <ActionButton
                  href='https://www.marriott.com/about/privacy.mi'
                  target='_blank'
                  text='Privacy Center'
                  className='dark'
                />
              </div>
            </form>
          </div>

          <div className='contact-image-container'>
            <div className='contact-image-wrapper'>
              <OptimizedImage
                avif={contactUsImageavif}
                webp={contactUsImagewebp}
                fallback={contactUsImage}
                alt='Connecting in nature'
                className='contact-hike-img'
              />
              <div className='contact-image-overlay top-left'>
                Lasting connections along the travel journey and beyond
              </div>
              <div className='contact-image-overlay bottom-right'>
                Turning complex challenges into repeatable successes
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default Contact;
